// removed by extract-text-webpack-plugin
module.exports = {"button-group":"remove-self-modal__button-group___1fPsn"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/settings/remove-self-modal.scss
// module id = 1363
// module chunks = 0